var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "swiper-container",
    class: {
      'visible-arrows': _vm.visibleArrows
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('client-only', [_vm.showArrows ? [_c('btn', {
    staticClass: "swiper-button-prev",
    class: {
      'is-disabled': _vm.isFirstSlide && !_vm.loop
    },
    attrs: {
      "aria-label": _vm.$trans('action.back', 'Zurück'),
      "icon": "",
      "disabled": _vm.isFirstSlide && !_vm.loop
    },
    on: {
      "click": _vm.slidePrev
    }
  }, [_c('icon', {
    attrs: {
      "icon": _vm.$icons.back,
      "x-large": "",
      "force-size": "",
      "color": "gray-400"
    }
  })], 1), _vm._v(" "), _c('btn', {
    staticClass: "swiper-button-next",
    class: {
      'is-disabled': _vm.isLastSlide && !_vm.loop
    },
    attrs: {
      "aria-label": _vm.$trans('action.next', 'Weiter'),
      "icon": "",
      "disabled": _vm.isLastSlide && !_vm.loop
    },
    on: {
      "click": _vm.slideNext
    }
  }, [_c('icon', {
    attrs: {
      "icon": _vm.$icons.next,
      "x-large": "",
      "force-size": "",
      "color": "gray-400"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _vm.showPagination ? _c('div', {
    staticClass: "flex items-center justify-center mb-16 mt-8"
  }, _vm._l(_vm.slideViews, function (slide, slideViewIndex) {
    return _c('div', {
      key: 'slide-pagination-' + slideViewIndex,
      staticClass: "w-10 h-10 mx-4 cursor-pointer rounded-full",
      class: _vm.activeSlideViewIndex === slideViewIndex ? 'bg-gray-400' : 'bg-gray-300',
      on: {
        "click": function ($event) {
          return _vm.slideTo(slideViewIndex);
        }
      }
    });
  }), 0) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }